import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import DetailRow from "../CustomComponents/DetailRow";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const DetailQuestionModal = ({ handleClose, data }) => {
  console.log(data);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleClose}>
        <div
          className={cssStyles.modalContainer}
          style={{ maxWidth: "90%", maxHeight: "90vh", overflowY: "auto" }}
        >
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">Details</p>
            <span
              className="bg-danger-hover d-flex p-3 rounded-5"
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            >
              <FaCircleXmark />
            </span>
          </div>
          <div className="w-100">
            <section>
              <Row>
                <Col md={6}>
                  <div className="my-2 w-100">
                    <audio controls preload="none" style={{ width: "180px" }}>
                      <source src={data?.audio_url} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                  <DetailRow title={"Question"} value={`${data?.question}`} />
                  <DetailRow
                    title={"Description"}
                    value={`${data?.description}`}
                  />
                  <DetailRow title={"Hints"} value={`${data?.hints}`} />
                  <DetailRow
                    title={"Category"}
                    value={`${data?.category?.name}`}
                  />
                </Col>
                <Col md={6}>
                  <DetailRow title={"Options"} />
                  <ul
                    className="text-wrap-custom"
                    style={{ paddingLeft: "1rem", marginBottom: 0 }}
                  >
                    {data?.options?.map((opt) => (
                      <li key={opt.id}>{opt.option}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </section>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default DetailQuestionModal;
